import { Helmet } from "react-helmet";
import { useSiteSettings } from "@/hooks/useSiteSettings";

const MetaTags = () => {
  const { data: settings } = useSiteSettings();

  if (!settings) return null;

  return (
    <Helmet>
      {/* Dynamic SEO */}
      <title>{settings.site_name ? `${settings.site_name} - ${settings.site_description || ""}` : "جنّة - منتجات غذائية طبيعية بجودة عالية"}</title>
      <meta name="description" content={settings.site_description || "جنّة تقدم لك أجود المنتجات الغذائية الأساسية بالجملة من دقيق وسكر وأرز وتوابل بأعلى جودة وأفضل الأسعار"} />
      
      {/* Social Media Tags */}
      <meta property="og:title" content={settings.site_name || "جنّة - منتجات غذائية طبيعية بجودة عالية"} />
      <meta property="og:description" content={settings.site_description || "جنّة تقدم لك أجود المنتجات الغذائية الأساسية بالجملة من دقيق وسكر وأرز وتوابل بأعلى جودة وأفضل الأسعار"} />
      <meta property="og:image" content={settings.hero_image || "/hero-main.jpg"} />
      <meta property="og:type" content="website" />
      
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={settings.site_name || "جنّة - منتجات غذائية طبيعية بجودة عالية"} />
      <meta name="twitter:description" content={settings.site_description || "جنّة تقدم لك أجود المنتجات الغذائية الأساسية بالجملة من دقيق وسكر وأرز وتوابل بأعلى جودة وأفضل الأسعار"} />
      <meta name="twitter:image" content={settings.hero_image || "/hero-main.jpg"} />

      {/* Dynamic Favicon */}
      <link rel="icon" href={settings.favicon_url || "/logo-main.jpg"} />
      <link rel="shortcut icon" href={settings.favicon_url || "/logo-main.jpg"} />

      {/* Verification & Scripts */}
      {settings.google_site_verification && (
        <meta name="google-site-verification" content={settings.google_site_verification} />
      )}
      {settings.header_scripts && (
        <script type="text/javascript">{settings.header_scripts}</script>
      )}
    </Helmet>
  );
};

export default MetaTags;
